<template>
  <div class="box">
    <ApexChart
      width="99%"
      height="160"
      type="area"
      :options="chartOptions"
      :series="chartSeries"
    />
    <BLoading
      :active.sync="loading"
      :is-full-page="false"
    />
  </div>
</template>

<script>
import moment from 'moment';
import merge from 'lodash/merge';
import { createNamespacedHelpers } from 'vuex';

const { mapState, mapGetters, mapActions } = createNamespacedHelpers('statistics');

const genChartOptions = (text, labels) => ({
  chart: {
    id: 'DashboardStatisticsSalesMonth',
    height: '250px',
    type: 'area',
    sparkline: { enabled: false },
    toolbar: { show: false },
  },
  toolbar: { show: false },
  stroke: { curve: 'straight' },
  fill: { opposite: 1 },
  yaxis: {
    min: 0,
    forceNiceScale: true,
    labels: {
      show: true,
      align: 'left',
      style: {
        fontSize: '8px',
      },
    },
  },
  xaxis: {
    type: 'dateTime',
    labels: {
      show: false,
      align: 'left',
      style: {
        fontSize: '8px',
      },
      rotate: -90,
    },
    tooltip: {
      enabled: false,
    },
  },
  axisTicks: { show: false },
  colors: ['#0BA23B', '#306A9B'],
  title: {
    text,
    offsetX: 30,
    style: { fontSize: '24px', cssClass: 'apexcharts-yaxis-title' },
  },
  subtitle: {
    text: 'Ventas en el mes',
    offsetX: 30,
    style: { fontSize: '14px', cssClass: 'apexcharts-yaxis-title' },
  },
  dataLabels: {
    enabled: false,
  },
  legend: {
    show: false,
  },
  labels,
});

export default {
  name: 'DashboardStatisticsSalesMonth',
  data() { return { loading: false }; },
  computed: merge(
    mapState({ sales: ({ salesMonth }) => salesMonth }),
    mapGetters([
      'sumSalesMonthTotalCurrency',
      'salesMonthLabels',
      'salesMonthSeries',
      'salesMonthTotalCurrencyNonFiscal',
      'salesMonthLabelsNonFiscal',
      'salesMonthSeriesNonFiscal',
    ]),
    {
      chartOptions() {
        if (this.salesMonthLabels.length > 1) {
          return genChartOptions(this.sumSalesMonthTotalCurrency, this.salesMonthLabels);
        }

        const date = moment({ d: 0, h: 0, m: 0 }).subtract(1, 'month');
        const labels = [date.format('YYYY-MM'), ...this.salesMonthLabels];

        return genChartOptions(this.sumSalesMonthTotalCurrency, labels);
      },
      chartSeries() {
        if (this.salesMonthSeries.length > 1) {
          return [
            { name: 'Fiscal', data: this.salesMonthSeries },
            { name: 'No Fiscal', data: this.salesMonthSeriesNonFiscal },
          ];
        }

        return [
          { name: 'Fiscal', data: [0, ...this.salesMonthSeries] },
          { name: 'No Fiscal', data: [0, ...this.salesMonthSeriesNonFiscal] },
        ];
      },
    },
  ),
  async beforeMount() {
    this.loading = true;
    const now = new Date();

    await this.getSales({
      year: now.getFullYear(),
      month: now.getMonth() + 1,
    });

    this.loading = false;
  },
  methods: merge(mapActions(['getSales'])),
};
</script>

<style scoped>
</style>
